import { DocumentAPI } from '../../../types/salesforce/api/document/document-api';
import { OnboardingDocument } from '../../../types/application/onboarding-document';

export function getDocumentApiFromOnboardingDocument(
  onboardingDocument: OnboardingDocument,
  documentBody?: string,
): DocumentAPI {
  return {
    documentName: onboardingDocument.documentName,
    documentType: onboardingDocument.documentType,
    documentBody: documentBody,
    idNumber: onboardingDocument.idNumber,
  } as DocumentAPI;
}
